import { create } from 'zustand';
import api from '../services/api';

const useAuthStore = create((set) => ({
  user: JSON.parse(localStorage.getItem('bringhub_user') || 'null'),
  token: localStorage.getItem('bringhub_token') || null,
  isLoading: false,

  login: async (email, password) => {
    set({ isLoading: true });
    try {
      const { data } = await api.post('/auth/login', { email, password });
      const { token, user } = data.data; // envelope { success, data: { token, user }, message }
      localStorage.setItem('bringhub_token', token);
      localStorage.setItem('bringhub_user', JSON.stringify(user));
      set({ user, token, isLoading: false });
      return { success: true };
    } catch (err) {
      set({ isLoading: false });
      const errData = err.response?.data;
      return { success: false, error: errData?.message || errData?.error || 'Erro ao fazer login' };
    }
  },

  logout: () => {
    localStorage.removeItem('bringhub_token');
    localStorage.removeItem('bringhub_user');
    set({ user: null, token: null });
  },

  setUser: (user) => set({ user }),
}));

export default useAuthStore;
